import React, {useState} from "react"
import '../../css/pages/loginPage/LoginPage.css'

import {UnmountContextProvider} from '../../context/UnmountContext'
import useTogglePopUp from '../../hooks/useTogglePopUp'

import BrassPanel from '../../components/BrassPanel'
import PaperPanel from '../../components/PaperPanel'
import GameHeader from '../../components/GameHeader'
import InfoPopUp from '../../components/InfoPopUp'

import LoginForm from './LoginForm'
import LoginAltOptions from './LoginAltOptions'
import LoadingAnimation from './LoadingAnimation'

function LoginPage() {
    const [userKey, setUserKey] = useState('')
    const [loading, setLoading] = useState(false)
    const {isPopUpOpen, togglePopUp} = useTogglePopUp()
    
    return (
        <div className="pageContainer pageContainer-login">
            <GameHeader loginPage={true} />

            <main className="main-login">
                <PaperPanel extraClasses='login_title'>
                    <p className="login_title_small">The Case Of</p>
                    <h1 className="login_title_large">
                        The Kidnapped Professor
                    </h1>
                </PaperPanel>
                                
                <BrassPanel extraClasses='login_keyPanel'>
                    {loading ? 
                        <LoadingAnimation /> : 
                        <LoginForm
                            userKey={userKey}
                            setUserKey={setUserKey}
                            togglePopUp={togglePopUp}
                            loading={loading}
                            setLoading={setLoading}
                        />
                    }
                </BrassPanel>
                
                <LoginAltOptions />
                
                <UnmountContextProvider>
                    <InfoPopUp isPopUpOpen={isPopUpOpen} togglePopUp={togglePopUp}>
                        <p className="infoPopUp_text">
                            Oops! Something went wrong, please try again or contact us if the problem continues.
                        </p>
                    </InfoPopUp>
                </UnmountContextProvider>
            </main>
        </div>
    )
}

export default LoginPage